import { createNewSessionIfNeeded } from '@src/quince-site-common/src/trackers/initializeAnalytics'
import { ANALYTIC_COOKIES } from '@src/quince-site-common/src/utils/constants'
import { getFromLocalStorageWithExpiry } from '@src/quince-site-common/src/utils/getFromLocalStorageWithExpiry'
import { createLastBrandUserId, getlbUserId } from '@src/quince-site-common/src/utils/getlb-user-id'
import { getCookie } from '@src/quince-site-integrated/src/utils'

export const vaildateLbUserId = () => {
  if (!getlbUserId() && !getFromLocalStorageWithExpiry(ANALYTIC_COOKIES.LB_USER_ID, false)) {
    createLastBrandUserId()
  }
}
export const vaildateSessionId = () => {
  if (!getCookie(ANALYTIC_COOKIES.SESSION_ID) && !getFromLocalStorageWithExpiry(ANALYTIC_COOKIES.SESSION_ID)) {
    createNewSessionIfNeeded()
  }
}
